module.exports = __webpack_public_path__ + "img/selection_help02.5f436ae1.gif";